import BgImg from '~/assets/holiday/new-year/menu/bg.png';
import { BaseMenu } from './BaseMenu';

export const NewYearMenu = () => (
  <BaseMenu
    config={{
      containerBgClass: 'bg-cover bg-top bg-no-repeat',
      containerStyle: { 'background-image': `url(${BgImg})` },
      collapseButtonZIndex: true,
      activeColor: '#E4684B',
      tooltipBgColor: '#E4684B',
      linkTooltipBgColor: '#BC4150',
    }}
  />
);
